export const CHART_SPACING = {
  cardPadding: 24,
  cardBorderRadius: 4,
  cardMinHeight: 428,
  sectionMarginTop: 22,
} as const;
